import React, { Suspense } from 'react';
import '@src/i18n';

import { ScooberAppsLayout } from '@src/apps/ScooberApps/layouts/ScooberAppsLayout';
import { ScooberTheme } from '@src/apps/ScooberApps/components/ScooberTheme';
(window as any).usabilla_live('hide');
export const Scoober = () => {
  return (
      <Suspense fallback={'loading....'}>
            <ScooberTheme>
              <ScooberAppsLayout/>
            </ScooberTheme>
            
      </Suspense>

  );
};

export default Scoober;
